import { render } from "./DisplayLink.vue?vue&type=template&id=4cca40d4"
import script from "./DisplayLink.vue?vue&type=script&lang=js"
export * from "./DisplayLink.vue?vue&type=script&lang=js"

import "./DisplayLink.vue?vue&type=style&index=0&id=4cca40d4&lang=less"
import "./DisplayLink.vue?vue&type=style&index=1&id=4cca40d4&lang=less"

import exportComponent from "/Users/mac/Documents/Tranzak/Frontend/collections/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__